export const userAllowedToApprove = user => user?.roles?.includes('admin') || user?.roles?.includes('dvg_passenger_review');
export const userIsAllowedToViewBasicDetails = user => user.roles?.includes('app-verify-user') || user?.roles?.includes('admin');
export const userIsAllowedToTagEvents = user => user.roles?.includes('app-tag-events') || user?.roles?.includes('admin');
